<template>
  <section class="timeTplCaseDetail">
    <section class="viewTitle">
      <viewTitle
        :showReturn="true"
        title="业务管理 / 基础数据管理 / 预约时间实例 / 修改号源"
      />
    </section>

    <div class="main">
      <el-form label-position="left" label-width="145px">
        <el-form-item label="模板名称">
          {{ timeTpObj.modelName || "--" }}
        </el-form-item>
        <el-form-item label="实例时间">
          {{ formatTime(timeTpObj.bookingDay) || "--" }}
        </el-form-item>
        <el-form-item label="已预约总量">
          {{ useTotalNumber || "--" }}
        </el-form-item>
        <el-form-item label="已预约汇总">
          <div class="sourceResult">
            <template v-for="(item, index) in useTotalNumberText">
              <div :key="index" type="info">
                <span>{{ item.group_name }}</span>
                <span>({{ item.used_number }}/{{ item.total_number }})</span>
              </div>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="每日号源划分">
          <div class="sourceResult" style="width: 500px;">
            <template v-for="(item, index) in timeTpObj.daySource">
              <el-tag
                :key="index"
                style="margin-right: 10px;"
                type="info"
                @click="
                  () => {
                    editSource(item, index);
                  }
                "
              >
                <span>『 {{ item.begin_time }} ~ {{ item.end_time }} 』</span>
                <span v-for="(group, index) in item.number" :key="index">
                  <span>{{ group.group_name }}</span>
                  <span
                  >（{{ group.used_number }}/{{
                      Number(group.total_number) == 0
                        ? "不限"
                        : group.total_number
                    }}）</span
                  >
                </span>
                <i class="el-icon-edit" style="float: right;"></i>
              </el-tag>
            </template>
          </div>
        </el-form-item>
        <el-form-item label="排队登记可延迟时间">
          <span>{{ timeTpObj.model_info.check_effectivity_time }}小时</span>
        </el-form-item>
        <el-form-item label="叫号后过期时间">
          <span>{{ timeTpObj.model_info.calling_effectivity_time }}分钟</span>
        </el-form-item>
        <el-form-item label="最小可预约时间">
          <span v-if="dataArr.min_booking_time > 0">
            {{ formatMin(timeTpObj.minRangKey) || "--" }}</span
          >
          <span v-else>无限制</span>
        </el-form-item>
        <el-form-item label="最大可预约时间">
          {{ maxRangKeyDesc || "--" }}
        </el-form-item>
        <el-form-item label="使用状态">
          <template>
            <span v-if="Number(timeTpObj.useState) == 1" class="color67"
            >未使用</span
            >
            <span v-else-if="Number(timeTpObj.useState) == 2" class="color5E"
            >已使用</span
            >
            <span v-else-if="Number(timeTpObj.useState) == 3" class="color99"
            >已过期</span
            >
            <span v-else>--</span>
          </template>
        </el-form-item>
        <el-form-item label="创建日期">
          {{ timeTpObj.create_time }}
        </el-form-item>
        <el-form-item label="最后更新日期">
          {{ timeTpObj.update_time }}
        </el-form-item>
      </el-form>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :title="$route.params.id ? '修改每日号源划分' : '添加每日号源划分'"
      :visible.sync="dialogVisible"
      class="elDialog"
      width="770px"
    >
      <div>
        <el-row :gutter="20" align="middle" type="flex">
          <el-col :span="4"><span>时间段</span></el-col>
          <el-col :span="20">
            <el-time-picker
              v-model="sourceobj.timeRang"
              disabled
              end-placeholder="结束时间"
              format="HH:mm"
              is-range
              placeholder="选择时间范围"
              range-separator="至"
              start-placeholder="开始时间"
              value-format="HH:mm"
            >
            </el-time-picker>
          </el-col>
        </el-row>
        <template v-for="(business, index) in sourceobj.businessArr">
          <el-row :key="index" :gutter="20" type="flex">
            <el-col :span="4"><span v-if="Number(index) == 0">业务组设置</span></el-col>
            <el-col :span="20">
              <div class="divRow">
                <el-select v-model="business.opKey" clearable disabled placeholder="请选择业务组">
                  <el-option v-for="item in businessList"
                             v-show="sourceobj.opKeyList.indexOf(item.id) < 0"
                             :key="item.id"
                             :label="item.name"
                             :value="item.id">
                  </el-option>
                </el-select>
                <el-radio v-model="business.timeType" class="elRadio1" label="1" @change=" () => { business.sum = ''; }">数量不限</el-radio>
                <el-radio v-model="business.timeType" class="elRadio1" label="2" @change="handleLimitSums(index)">限定数量</el-radio>
                <el-input v-if="Number(business.timeType) == 2" v-model="business.sum" placeholder="数量"></el-input>
                <el-input v-else v-model="business.sum" disabled placeholder="数量"></el-input>

                <span>已使用：<span class="color67">{{ business.used_number }}</span></span>

                <template v-if="getGrouoItem(business.opKey)">
                  <section v-for="item in getGrouoItem(business.opKey).sub_business_list" :key="item.id" style="padding: 10px 0 0;">
                    <template v-if="business.detail[item.id]">
                      <el-input :value="item.name" readonly style="width: 200px;"></el-input>
                      <el-input @input="handleLimitSums(index)" v-model="business.detail[item.id].total_number" placeholder="数量"></el-input>
                      <span>已使用：<label style="color: red;">{{ business.detail[item.id].used_number || 0 }}</label></span>
                    </template>
                  </section>
                </template>
              </div>
            </el-col>
          </el-row>
        </template>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="comfireSourceobj">保 存</el-button>
      </span>
    </el-dialog>
  </section>
</template>
<script>
import viewTitle from "@/components/viewTitle";
// import confirm from "@/components/elementPlus/packages/confirm";
import moment from "moment";

export default {
  props: {},
  data() {
    return {
      jsonCarDefault: {},
      timeTpObj: {
        name: "",
        timeType: "",
        timeRang: [],
        delDay: [],
        addDay: [],
        checkList: [],
        minRangList: [
          {
            value: "3600",
            label: "不小于1小时"
          },
          {
            value: "7200",
            label: "不小于2小时"
          },
          {
            value: "10800",
            label: "不小于3小时"
          },
          {
            value: "14400",
            label: "不小于4小时"
          },
          {
            value: "18000",
            label: "不小于5小时"
          }
        ],
        maxRangList: [
          {
            value: "1",
            label: "1天内"
          },
          {
            value: "2",
            label: "2天内"
          },
          {
            value: "3",
            label: "3天内"
          },
          {
            value: "7",
            label: "7天内"
          },
          {
            value: "15",
            label: "15天内"
          },
          {
            value: "30",
            label: "30天内"
          }
        ],
        options: [],
        textarea: "",
        minRangKey: "",
        maxRangKey: "",
        daySource: [],
        model_info: {}
      },
      dataArr: {},
      dialogVisible: false,
      businessList: [],
      sourceobj: {
        timeRang: ["8:00", "9:00"],
        opKeyList: [],
        businessArr: [
          {
            opKey: "",
            timeType: "",
            sum: "",
            detail: {}
          }
        ],
        index: ""
      },
      delDayTimePlugin: "",
      addDayTimePlugin: ""
    };
  },
  watch: {},
  components: { viewTitle },
  computed: {
    getGrouoName() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item.name;
          }
        }
      };
    },
    getGrouoItem() {
      return id => {
        for (let i = 0; i < this.businessList.length; i++) {
          let item = this.businessList[i];
          if (id == item.id) {
            return item;
          }
        }
      };
    },
    // minRangKeyDesc() {
    //   let text = "";
    //   this.timeTpObj.minRangList.forEach(item => {
    //     if (Number(this.timeTpObj.minRangKey) == Number(item.value)) {
    //       text = item.label;
    //     }
    //   });
    //   return text;
    // },
    maxRangKeyDesc() {
      let text = "";
      this.timeTpObj.maxRangList.forEach(item => {
        if (Number(this.timeTpObj.maxRangKey) == Number(item.value)) {
          text = item.label;
        }
      });
      return text;
    },
    useTotalNumber() {
      let sum = 0;
      this.timeTpObj.daySource.forEach(item => {
        item.number.forEach(el => {
          sum += Number(el.used_number);
        });
      });
      return sum;
    },
    useTotalNumberText() {
      let useObj = {};
      this.timeTpObj.daySource.forEach(item => {
        let totalNumberAdd = true;
        item.number.forEach(el => {
          if (Number(el.total_number) == 0) {
            totalNumberAdd = false;
          }
          if (useObj[el.group_id]) {
            useObj[el.group_id].used_number += Number(el.used_number);
            if (!totalNumberAdd) {
              useObj[el.group_id].total_number = "不限";
            } else {
              useObj[el.group_id].total_number += Number(el.total_number);
            }
          } else {
            useObj[el.group_id] = {
              group_name: el.group_name,
              used_number: Number(el.used_number)
            };
            if (!totalNumberAdd) {
              useObj[el.group_id].total_number = "不限";
            } else {
              useObj[el.group_id].total_number = Number(el.total_number);
            }
          }
        });
      });
      return useObj;
    },
    handleMap() {
      return (array = [], key = 'id') => {
        let map = {};
        for (let i = 0;i < array.length; i++) {
          map[array[i][key]] = array[i]
        }
        return map
      }
    },
  },
  methods: {
    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },
    editSource(item, index) {
      this.dialogVisible = true;
      this.sourceobj.opKeyList = [];
      this.sourceobj.businessArr = [];
      this.sourceobj.timeRang = [item.begin_time, item.end_time];
      item.number.forEach(group => {
        this.sourceobj.opKeyList.push(group.group_id);
        const { detail = {} } = group;
        let params = {
          opKey: group.group_id,
          timeType: Number(group.total_number) == 0 ? "1" : "2",
          sum: Number(group.total_number) > 0 ? group.total_number : "",
          used_number: Number(group.used_number),
          id: group.id,
          group_name: group.group_name,
          detail: {}
        }
        let new_detail = null;
        if (Array.isArray(detail)) {
          new_detail = {
            ...this.jsonCarDefault
          }
        } else {
          new_detail = detail
        }
        for (let item in new_detail) {
          let new_item = {
            ...new_detail[item],
            total_number: new_detail[item].total_number == '-1' ? '' : new_detail[item].total_number
          }
          new_detail[item] = new_item
        }
        params.detail = new_detail;
        this.sourceobj.businessArr.push(params);
      });
      this.sourceobj.index = index;
    },
    comfireSourceobj() {
      let groupNumber = [];
      // for (let i = 0; i < this.sourceobj.businessArr.length; i++) {
      //   let item = this.sourceobj.businessArr[i];
      //   let detail = item.detail || {};
      //   let truck_total = 0;
      //   for (let key in detail) {
      //     let map = this.handleMap(this.carTypes, 'key');
      //     let ragex = /^\d+$/;

      //     if (!(detail[key].total_number >= 0 && ragex.test(detail[key].total_number))) {
      //       if (detail[key].total_number == '') {
      //         if (Number(item.timeType) === 2) {
      //           this.$common.pcToastFail(`第${i + 1}项的${map[key].name}不能为非0或非正整数`);
      //           return false;
      //         }
      //       } else {
      //         this.$common.pcToastFail(`第${i + 1}项的${map[key].name}不能为非0或非正整数`);
      //         return false;
      //       }
      //     }

      //     if (detail[key].total_number != '' && +detail[key].total_number < +detail[key].used_number) {
      //       this.$common.pcToastFail(`第${i + 1}项的${map[key].name} 输入值不能小于已使用量`);
      //       return false;
      //     }

      //     truck_total += +detail[key].total_number
      //   }
      //   if (Number(item.timeType) === 2) {
      //     if (String(item.sum).trim() === "") {
      //       this.$common.pcToastFail(`第${i + 1}项的限定数量不能为空`);
      //       return false;
      //     }
      //     if (
      //       !String(item.sum).trim() &&
      //       Number(String(item.sum).trim()) !== 0
      //     ) {
      //       this.$common.pcToastFail(`第${i + 1}项的限定数量不能为非数字值`);
      //       return false;
      //     }
      //     if (
      //       String(item.sum)
      //         .trim()
      //         .indexOf(".") > 0
      //     ) {
      //       this.$common.pcToastFail(`第${i + 1}项的限定数量必须为正整数`);
      //       return false;
      //     }
      //     if (
      //       Number(String(item.sum).trim()) < 1 ||
      //       Number(String(item.sum).trim()) > 999
      //     ) {
      //       this.$common.pcToastFail(`第${i + 1}项的限定数量范围为1~999`);
      //       return false;
      //     }
      //     if (Number(String(item.sum).trim()) < Number(item.used_number)) {
      //       this.$common.pcToastFail(
      //         `第${i + 1}项的限定数量不能小于已使用的数量`
      //       );
      //       return false;
      //     }
      //     if (truck_total != +item.sum) {
      //       this.$common.pcToastFail(`第${i + 1}项业务组的车型号源总数不等于限定数量`);
      //       return false
      //     }
      //   }
      // }
      this.dialogVisible = false;
      this.sourceobj.businessArr.forEach(item => {
        let detail = {};
        // this.carTypes.map(item2 => {
        //   if (item.detail[item2.key] && item.detail[item2.key].total_number !== '') {
        //     detail[item2.key] = item.detail[item2.key].total_number
        //   } else {
        //     detail[item2.key] = -1
        //   }
        // })
        Object.keys(item.detail).forEach(key => {
          if (item.detail[key] && item.detail[key].total_number!== '') {
            detail[key] = item.detail[key].total_number 
          } else {
            detail[key] = -1
          }
        })
        groupNumber.push({
          number_id: item.id,
          number: Number(item.timeType) == 1 ? 0 : item.sum,
          detail
        });
      });
      this.$common
        .http({
          url: "/api/queue/admin/edit_business_time_instance",
          data: {
            data: JSON.stringify(groupNumber)
          }
        })
        .then(() => {
          this.getInitData(this.$route.params.id);
        });
      // let daySource = {
      //   begin_time: this.sourceobj.timeRang[0],
      //   end_time: this.sourceobj.timeRang[1],
      //   group_number: groupNumber
      // };
      // daySource = JSON.parse(JSON.stringify(daySource));
      // if (this.sourceobj.index.toString().length > 0) {
      //   this.timeTpObj.daySource[Number(this.sourceobj.index)] = daySource;
      // } else {
      //   this.timeTpObj.daySource.push(daySource);
      // }
    },
    backList() {
      this.$router.go(-1);
    },
    getInitData(id) {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_time_instance_detail",
          data: {
            id
          }
        })
        .then(res => {
          // console.log(res);
          this.dataArr = res.data.data;
          const data = res.data.data;
          this.timeTpObj.modelName = data.model_name;
          this.timeTpObj.model_info = data.model_info;
          this.timeTpObj.bookingDay = data.booking_day;
          // this.timeTpObj.id = data.id;
          // this.timeTpObj.name = data.name;
          // this.timeTpObj.timeType = data.is_permanent_valid.toString();
          // if (data.is_permanent_valid.toString() == "2") {
          //   this.timeTpObj.timeRang = [
          //     data.begin_time.toString(),
          //     data.end_time.toString()
          //   ];
          // } else {
          //   this.timeTpObj.timeRang = [];
          // }
          // this.timeTpObj.holidayType = data.is_use_statutory_holidays.toString();
          // this.timeTpObj.addDay = data.exclude_day;
          // this.timeTpObj.delDay = data.extra_day;
          // this.timeTpObj.checkList = data.repeat_setting;
          this.timeTpObj.minRangKey = data.min_booking_time.toString();
          this.timeTpObj.maxRangKey = data.max_booking_day.toString();
          // this.timeTpObj.textarea = data.note;
          this.timeTpObj.daySource = data.periods;
          this.timeTpObj.create_time = this.formatTime(data.create_time);
          this.timeTpObj.update_time = this.formatTime(data.update_time);
          // this.timeTpObj.valid_state = data.valid_state;
          this.timeTpObj.useState = data.use_state;
          // this.timeTpObj.used_instance_num = data.used_instance_num;
          // this.timeTpObj.instance_num = data.instance_num;
          // this.timeTpObj.history_num = data.history_num;
        });
    },
    getBusinessList() {
      this.$common
        .http({
          url: "/api/queue/admin/query_business_group",
          data: {
            keyword: "",
            state: 1,
            page_size: 1000
          }
        })
        .then(res => {
          this.businessList = res.data.data.data;
        });
    },
    // 格式化最小可预约时间
    formatMin(str) {
      if (str === 0) {
        return `无限制`;
      } else {
        return `不小于${parseFloat((str / 60 / 60).toFixed(2))}小时`;
      }
    },
    handleLimitSums(index) {
      let total = 0;
      for (let key in this.sourceobj.businessArr[index].detail) {
        total += +this.sourceobj.businessArr[index].detail[key].total_number
      }
      this.sourceobj.businessArr[index].sum = total
    }
  },
  created() {
    this.getBusinessList();
    if (this.$route.params.id) {
      this.getInitData(this.$route.params.id);
    }
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";

.timeTplCaseDetail {
  height: 100%;
  overflow-y: auto;
  overflow-x: hidden;

  .main {
    padding: 5px 16px;

    .el-row {
      padding-bottom: 18px;
    }

    .el-col-4 {
      text-align: right;
    }

    .elRadio1 {
      width: 70px;
    }

    .el-tag {
      margin-right: 5px;
      margin-bottom: 5px;
    }

    .addDay {
      color: #409eff;
      font-size: 20px;
      cursor: pointer;
    }

    .c4b {
      padding: 10px 10px 5px 10px;
      border: 1px solid #cecece;
    }

    .full100 {
      display: flex;
      align-items: center;

      .w100 {
        width: 100%;
      }
    }

    .dayDiv {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }

    .el-select {
      width: 100%;
    }

    .sourceResult {
      .desc {
        display: inline-block;
        padding-bottom: 10px;
      }

      .el-tag {
        display: inline-block;
        white-space: normal;
        height: auto;
        line-height: 17px;
        padding: 6px 8px;
        position: relative;
        width: 100%;
        font-size: 13px;
      }
    }
  }

  .elDialog {
    .el-row {
      padding-bottom: 18px;
    }

    .divRow {
      display: flex;
      align-items: center;
      flex-wrap: wrap;

      .el-radio {
        margin-right: 10px;
      }

      .el-select {
        width: 200px;
        margin-right: 10px;
      }

      .el-input {
        width: 100px;
        margin-right: 10px;
      }
    }

    .el-col-4 {
      text-align: right;
    }

    .plus {
      color: #409eff;
      cursor: pointer;
    }

    .close {
      color: coral;
      cursor: pointer;
    }
  }
}
</style>
<style lang="less">
.timeTplCaseDetail {
  .el-date-editor .el-range-separator {
    line-height: 24px;
  }

  .sourceResult {
    .el-tag {
      .el-icon-close {
        right: 8px;
        top: 50%;
        transform: translate(0, -50%);
        position: absolute;
      }
    }
  }

  .delDayTimePlugin,
  .addDayTimePlugin {
    width: 0;
    opacity: 0;

    > input {
      border: 0 !important;
      padding: 0;
    }
  }

  .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
